<template>
    <div class="jo-dispformula" :style="{'overflow-x':mathStyle}" :id="data.id">
      <table>
        <tbody><tr>
          <td width="42"></td>
          <td align="center" v-if="this.data.data && this.data.data.length > 0" ref="math">
            <component :is="'jo' + item.name" v-for="item in this.data.data" v-bind:key="item.index" v-bind:showBig = "true"
                       v-bind:data="item.data" v-bind:class="{'jo-dispformula-text':item.name=='text' && item.data.search(/[,.，。;；]/g)>=0}"></component>
          </td>
          <td width="100" align="right"><span class="index">
            <component :is="'jo' + item.name" v-for="item in this.data.label" v-bind:key="item.index" v-bind:data="item.data"></component>
          </span></td>
        </tr></tbody>
      </table>
    </div>
</template>

<script>
  import jomath from './math.vue'
  export default {
    components: {
      jomath,
    },
    props: [
        'data'
    ],
    data () {
      return {
        width: 10,
        mathStyle:'auto'
      }
    },
    created () {
      // this.width = this.data.graphics.width * this.GLOBAL.deviceDPI.x / 25.4*1.2
    },
    mounted(){
      let _this = this;
      let isIE = navigator.userAgent.indexOf('MSIE 9.0')>0 || navigator.userAgent.indexOf('rv:11.0')>0;
      if (isIE){
        _this.mathStyle = 'hidden';
        this.$nextTick(function () {
          if (typeof MathJax !== 'undefined'){
            MathJax.Hub.Queue(["Typeset", MathJax.Hub],[_this.setOverflow]);
          } else _this.setOverflow();
        })
      }

    },
    methods:{
      setOverflow(){
        if ($(this.$refs.math).width() > $('.jo-dispformula').width()-84){
          this.mathStyle = 'auto'
        }
      }
    }
  }
</script>
<style lang="scss">
    .jo-dispformula {
      margin:3px 0 25px 0;
      /*overflow-x: auto;*/
      overflow-y: hidden;
      width: 100%;
      table {
        max-width: 100%;
        min-width: 50%;
        margin: 10px auto 0px auto;
        -webkit-border-horizontal-spacing: 0px;
        -webkit-border-vertical-spacing: 0px;
        font-size: 1.6rem;
        width: 100%;
        color: #333;
        td{
          padding: 5px 0;
          word-break: break-all;
        }
      }
      .jo-dispformula-text {
        vertical-align: bottom;
      }
      .index {
        word-break: keep-all;
        color: #333;
        font-weight: normal;
        font-size: 13px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/maincontent/body/formula/dispformula.vue